import React from 'react'
import InvoiceGenerator from './newTemplate/InvoiceGenerator'

const Invoice = () => {
  return (
    <InvoiceGenerator />
  )
}

export default Invoice;
